import request from '@/utils/request'
const apiPath = '/sys/sysDataCompareLog'
import { downloadBlob } from '@/utils/download'
const sysDataCompareLogApi = {
  /**
   * 分页查询【日志】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  loginLogList(query) {
    return request.post(apiPath + '/loginLogList', query)
  },
  exportLoginLog(query) {
    return request.get(apiPath + '/exportLoginLog', { params: query })
  },
  fetchById(id) {
    return request.get(`${apiPath}/showdiy/${id}`)
  },
}
export default sysDataCompareLogApi
